import { render, staticRenderFns } from "./NavigateTop.vue?vue&type=template&id=c361ceca&scoped=true&"
import script from "./NavigateTop.vue?vue&type=script&lang=js&"
export * from "./NavigateTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c361ceca",
  null
  
)

export default component.exports